module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C765"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("3")])])]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('p', {
    staticClass: "C773"
  }, [_c('strong', [_vm._v("United States Earnings Dynamics")])]), _vm._v(" "), _c('p', {
    staticClass: "C773"
  }, [_vm._v("Inequality, Mobility, and Volatility")]), _vm._v(" "), _c('p', {
    staticClass: "C766"
  }, [_vm._v("Kevin L. McKinney, John M. Abowd, and John Sabelhaus")]), _vm._v(" "), _c('p', {
    staticClass: "C845"
  }, [_c('strong', [_vm._v("3.1 Introduction")])])]), _c('p', {
    staticClass: "P51"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("Using data from the US Census Bureau’s Longitudinal Employer-Household Dynamics (LEHD) infrastructure files, we study changes over time and across subnational populations in the distribution of real labor earnings and earnings dynamics. At the national level, LEHD administrative data has been used to show earnings inequality is increasing, while worker mobility is declining (Abowd, McKinney, and Zhao 2018; hereafter AMZ). In addition, overall earnings volatility is declining in administrative data (Bloom et al. 2017; Sabelhaus and Song 2010), but earnings volatility of workers with weak labor force attachment is increasing (McKinney and Abowd 2019). Although these national-level trends are well established, relatively little is known about earnings inequality, mobility, and volatility at subnational geographies. This chapter is a first step in that direction, using LEHD data to study earnings distributions and earnings dynamics ")]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("across four large metropolitan statistical areas (MSAs) over the period 1998 through 2017. The results exemplify the sorts of analyses that will be possible with a new data exploration tool—the Earnings and Mobility Statistics (EAMS) web application—currently under development at the US Census Bureau.")])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _c('div', {
    staticClass: "C1136"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _c('a', {
    attrs: {
      "id": "id_857"
    }
  }, [_c('img', {
    staticClass: "img60",
    attrs: {
      "alt": "",
      "src": "html/images/84_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "id_857"
    }
  }, [_c('p', {
    staticClass: "C1138"
  }, [_c('strong', [_vm._v("Fig. 3.1 Output growth, unemployment, employment growth, and earnings growth by MSA, 2001 to 2018")])])])]), _c('a', {
    attrs: {
      "id": "id_857"
    }
  }), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "id_857"
    }
  }, [_vm._v("Disaggregating earnings distributions and earnings dynamics by geography is motivated in large part by observed differences in economic and labor market conditions across local areas. ")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_857"
    }
  }, [_vm._v("Figure 3.1")]), _vm._v(" shows a wide range of outcomes for real GDP, unemployment, employment, and real annual earnings during our study period across the four MSAs (Detroit, Los Angeles, New York, and San Francisco) we consider in this chapter. All four MSAs show the negative effects of the Great Recession and subsequent slow recovery, but the size of the shocks and postrecession trajectories "), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("differ substantially. For example, Detroit experienced larger labor market and output shocks than the other three areas, from which they have been slower to recover, while San Francisco experienced less of a shock, followed by a much stronger recovery in employment and earnings. There are also clear differences in the prerecession economic conditions across MSAs, with Detroit experiencing notably high unemployment rates and slow output and earnings growth in the period 2001 through 2007, relative to the other areas and the overall national average.")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('div', {
    staticClass: "C1136"
  }, [_c('p', {
    staticClass: "C1135"
  }, [_c('img', {
    staticClass: "img60",
    attrs: {
      "alt": "",
      "src": "html/images/85_1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C1138"
  }, [_c('strong', [_vm._v("Fig. 3.1")])])])]), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("The differences in output, employment, and earnings across MSAs can be cautiously interpreted in terms of the same economic and demographic factors generally put forth as explaining rising earnings inequality and wage polarization. For example, Detroit and San Francisco are thought to be representative of two distinct types of local economies. Detroit is gener")]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("ally characterized as manufacturing-oriented, and thus more exposed to the direct effects of import penetration and automation. The persistent decline in manufacturing employment and consequent increase in the relative supply of lesser-skilled employment has arguably combined with skill-biased technical change to limit earnings growth. San Francisco is generally characterized as emblematic of a local economy dominated by booming high-tech industries, and thus much less exposed to those same forces. What is not clear is whether there are differences in labor market outcomes between Detroit and San Francisco for otherwise similar workers. For example, earnings and employment outcomes for high school–educated males at the national level are deteriorating generally. Is this because workers in that group are more concentrated in areas such as Detroit where they are much worse off? Is it possible the same demographic group in San Francisco is only slightly worse off or even experiencing earnings growth more in line with the rest of the population?")])]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("Although the four overall measures of economic outcomes in ")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_857"
    }
  }, [_vm._v("figure 3.1")]), _vm._v(" are suggestive of underlying factors driving earnings inequality, mobility, and volatility, the measures are incomplete. For example, starting in 2012 real average earnings in San Francisco grew faster than the rest of the country generally—and Detroit in particular—but that could be due to very rapid growth at the top of the earnings distribution. Alternatively, is upward mobility more prevalent throughout the entire earnings distribution, meaning a rising local area tide is lifting all boats? Overall differences in employment and output growth across MSAs lead to another set of questions about the role of entry and exit into the paid labor force. Detroit saw a huge drop in employment during the Great Recession relative to the other MSAs and the national average, but since 2012 it has seen similar employment growth rates. How much of the differences in levels is due to (presumably low or negative) population growth and how much is due to persistently lower labor force participation?")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("Questions about what is driving the overall labor force and earnings outcomes in "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_857"
    }
  }, [_vm._v("figure 3.1")]), _vm._v(" at the local level can be answered with the LEHD data using an empirical approach recently developed and implemented at the national level by AMZ. The LEHD data begin with the universe of jobs, and AMZ show that limiting the universe to observations with valid social security numbers (SSNs) effectively transforms the LEHD data from a “found” to a “designed” frame. AMZ show that the designed LEHD frame tracks the trends (if not the levels) in the data sets commonly used to study earnings inequality, such as the Current Population Survey (CPS) and American Community Survey (ACS). In addition, the scale, scope, and longitudinal structure of the LEHD data make it possible to study earnings dynamics in ways that are not possible with the CPS or ACS. For example, the patterns of earnings volatility in the LEHD data reported by McKinney and Abowd ("), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("2019) are shown to track the volatility patterns based on Social Security Administration earnings data in Bloom et al. (2017).")])]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('p', {
    staticClass: "P4"
  }, [_vm._v("The fixed real earnings “bin” is the key methodological building block in the AMZ empirical approach to studying earnings inequality, mobility, and volatility, and we take the same approach here. Most other analyses of earnings inequality are based on relative distributions, for example, considering the average earnings within a given distributional fractile, or the ratio of (say) the 90th to the 10th percentile cutoff. That approach is useful for describing trends in earnings levels within a given population but it is less useful for studying earnings dynamics or comparing outcomes across subpopulations. Percentile cutoffs can be problematic because they vary over time and across subpopulations in ways that may be correlated with the phenomenon being studied. For example, a drop in employment among previously low earners will shift all percentile cutoffs up and make it appear (erroneously) as though earnings have become more equal, when in fact the previously low earners are now much worse off.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("Establishing a fixed overall earnings distribution based on all time periods and subpopulations makes it possible to observe and evaluate "), _c('em', [_vm._v("where")]), _vm._v(" in the earnings distribution there are differences across subpopulations and at different points in time. Does San Francisco have higher mean earnings growth than Detroit because workers are generally shifting to the right across all or most fixed earnings cells or is it the case that earnings in San Francisco are just becoming more skewed, meaning the binned employment distributions are stable but earnings within the top earnings cell are increasing? Fixing the reference earnings distribution also makes it possible to disaggregate the source of the change across distributional fractiles. Is the flow between unemployment/nonparticipation and various earnings fractiles the same across MSAs or (for example) is someone who loses a job in Detroit more likely to remain out of the labor force? Also, are the positive and negative flows somehow different, meaning (for example) Detroit sees much more earnings-reducing job destruction than other MSAs?")])]), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("The LEHD data enable drilling down into the published MSA-level GDP, unemployment, employment, and earnings statistics to provide some preliminary answers to these overarching questions. We present standard measures of earnings inequality, such as the Gini coefficient, but the mixed signals (inverted U-shape between 1998 and 2017 but generally little changed on net over the entire period in all four MSAs) could reflect offsetting movements in different parts of the earnings distributions. Therefore, we also look at pairwise discretized earnings densities within and across MSAs and find both common cyclical components and divergent longer run trends. Consistent with the overall macro charts (")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_857"
    }
  }, [_vm._v("figure 3.1")]), _vm._v(") all four MSAs experienced large employment and output shocks in the Great Recession, and that is reflected in earnings distributions (for those who are employed) that are "), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("essentially unchanged between 2007 and 2011. Earnings distributions are shifting steadily to the right in the prerecession period in all four local areas, though to different degrees. In the postrecession period, only San Francisco has seen anything like a resumption of prerecession widespread earnings growth across the entire earnings distribution.")])]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('p', {
    staticClass: "P4"
  }, [_vm._v("Conventional inequality measures and univariate earnings distributions capture the earnings only of the employed; hence, those statistics fail to capture the distributional impacts of cyclical downturns associated with increased transitions to unemployment. The LEHD data permit the analysis of earnings mobility as we can track workers as they move in and out of employment covered by unemployment insurance (UI). We find both trend differences and common cycles in the entry and exit rates across our four MSAs. The most obvious commonality is in the cyclical entry to and exit from UI-covered employment, as exits from the UI-covered employment sector surged in 2008 and 2009, while rates of entry to covered UI employment fell. Rates of entry (which include reentry of those who moved to inactivity in 2008 and 2009) rose only slowly thereafter, consistent with a slow decline in unemployment and the prolonged declines in measured labor force participation in the wake of the Great Recession. On net, by the end of the study period in 2017, the number of workers entering and exiting paid employment had generally converged back to the 1998–99 levels in most of the MSAs we study here, except in Detroit, where inflows and outflows were each about 20 percent below the base period.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("Earnings mobility and earnings volatility are complementary ways to characterize longitudinal earnings dynamics of the continuously employed. In the fixed real earnings bin methodology, mobility is the movement between earnings bins measured over some time period. We disaggregate workers into mobility types in a given year using distinct mobility paths, such as the transition from earnings bin 1 to earnings bin 2, earnings bin 1 to earnings bin 3, and so on. This mobility path approach makes it possible to address, for example, how the longer-term earnings of workers who experienced a negative earnings shock in a given year compared to workers who were in the same base period real earnings bin but did not experience the shock. The different mobility paths are also key to understanding declining earnings volatility for all four MSAs. Some mobility paths are associated with substantial volatility as they involve economically meaningful earnings changes (say, bin 5 to bin 1, or vice versa) but in fact, overall volatility is dominated by the effects of large percentage movements in relatively low earnings. Workers who remained in the lowest real earnings bin (below $18,000 annually) in two adjacent periods account for roughly 25 percent of overall earnings volatility over the study period.")])]), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("Our MSA-level observations about earnings inequality, mobility, and volatility complement the growing literature on how substantial geographic differences in economic outcomes in the US have important implications ")]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("for labor market and macroeconomic policies. Abel and Dietz (2019) look at earnings distributions across select MSAs (including San Francisco and Detroit) using Census and ACS data, and find that earnings growth in San Francisco exceeded earnings growth in Detroit at every percentile of the earnings distribution over the period 1980 to 2015. Our findings are consistent with the Abel and Dietz paper in focusing attention on the role of better overall local labor market conditions and/or agglomeration, as opposed to fundamentals such as schooling or other human capital considerations.")])]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('p', {
    staticClass: "P4"
  }, [_vm._v("Other subnational labor market research has focused attention on international trade, housing, and even monetary policy, with an emphasis on how some initial shock or policy innovation generates spillovers that dominate local labor market outcomes. For example, one well-known paper considers how increased international trade differentially impacted local economies. Autor, Dorn, and Hanson (2013) use local labor market data to show substantial negative impacts from rising import penetration in areas where production was more concentrated in import-sensitive industries. More importantly, they show that there are substantial adjustment costs and second-round employment effects associated with import-related job destruction, and that fully considering those costs might substantially change one’s views about the gains from trade and the overall value of cheap imports.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("Housing policy also became a prominent policy topic in the Great Recession, especially given substantial differences in outcomes across subnational areas, and again the implications for local labor markets are key. Mian, Rao, and Sufi (2013) focus on the role of the housing boom and bust in determining regional labor market outcomes through both collateral and wealth channels. The key insight is that—and this is independent of what caused the housing boom and bust in the first place—carefully tracking outcomes in tradable and nontradable consumer goods across regions shows how a wealth shock can have disproportionate negative effects on a local economy. The extent to which the shock is distributed to other local labor markets depends on the extent to which local production is tradable. For example, a worker employed in the restaurant sector in a local area where tradable production declines is likely to be severely impacted, as the workers in the tradable sector cut back on their restaurant spending.")])]), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("Monetary policy has also been shown to have important differential geographic impacts, depending on local economic conditions. Beraja et al. (2018) show that the effects of expansionary monetary policy in the wake of the financial crisis varied by regions because of differences in loan-to-value ratios and other initial conditions. Similarly, Beraja, Hurst, and Ospina (2019) use regional data on employment and wages to separate the effects of shocks (aggregate demand and labor force participation) from the effects of wage stickiness in the Great Recession and find support for the idea that Phillips Curve principles may be operative regionally but that the relation")]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("ship between labor market tightness and wage growth is not observed at the national level because of vast differences by geography. These sorts of findings are consistent with what we see in the MSA-level LEHD earnings inequality, mobility, and volatility. It is likely that the different parts of the US have simultaneously experienced very different trend and cyclical phenomena, and thus different fiscal (and even monetary) policies across regions may be warranted. Indeed, Austin, Glaeser, and Summers (2018) characterize these issues in terms of “place-based” policies, arguing, for example, that policies focused on nonemployment are likely to have more bang for the buck in areas with high (and perhaps rising) rates of nonemployment.")])]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("In addition to directly contributing to the literature on regional economic differences, the other important contribution of this paper is to lay the foundation for a new data dissemination application under development at the US Census Bureau. The EAMS data extraction tool will complement several other tools made available to Census Bureau data users in recent years. These other tools include the Quarterly Workforce Indicators (QWI), Job to Job (J2J) Employment Flows, LEHD Origination Destination Employment Statistics (LODES), and most recently, the Post-Secondary Employment Outcomes (PSEO)."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/38_Notes#id_72",
      "id": "id_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" As in those other applications, users will be able to disaggregate labor market outcomes by a number of characteristics and display the results in many possible ways. Although our focus in this chapter is on subnational geography, we are investigating the feasibility of including demographic and firm characteristics from the LEHD infrastructure in the EAMS web application. This implies, for example, that users could see labor force entry/exit or movement across earnings bins disaggregated by age and gender.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("The remainder of the chapter proceeds as follows. In section 3.2 we describe the LEHD infrastructure, focusing on the particular criteria used to decide which LEHD records are included in the EAMS database generally, and the four MSAs here in particular. Section 3.3 turns to measures of inequality, including both conventional summary statistics, such as the Gini coefficient and top earnings shares, and much more detailed perspectives from (for example) discretized univariate earnings distributions. Section 3.4 focuses on earnings mobility, including average earnings dynamics among continuously employed workers based on their mobility paths across earnings bins, as well as movements into and out of paid employment. Section 3.5 builds on the mobility analysis and shows how earnings volatility varies across and along various earnings mobility paths and how the volatility of earnings along any given mobility path contributes to overall earnings volatility. Section 3.6 concludes.")]), _vm._v(" "), _c('p', {
    staticClass: "C826"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("3.2 Data and Methods")])])]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }), _c('p', {
    staticClass: "P51"
  }, [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("The empirical work in this chapter uses job-level earnings information from the LEHD infrastructure files, developed and maintained by the US Census Bureau."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/38_Notes#id_76",
      "id": "id_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" In the LEHD data infrastructure, a “job” is the statutory employment of a worker by a statutory employer as defined by the UI system in a given state. Mandated reporting of UI-covered wage and salary payments between one statutory employer and one statutory employee is governed by the state’s UI system. Reporting covers private employers and state and local government. There are no self-employment earnings unless the proprietor draws a salary, which is indistinguishable from other employees in this case.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("The LEHD program is based on a voluntary federal-state partnership. When a state becomes a member of the partnership, current as well as all available historical data for that state are ingested into the LEHD internal database. By 2004, LEHD data represent the complete universe of statutory jobs covered by the UI system in the US. However, studying job-level inequality—the task for which having a complete job frame is well suited—as a proxy for person-level inequality may be misleading due to the time-varying many-to-one assignment of jobs to workers. Therefore, we use all jobs to construct person-level annual real earnings (2017 Consumer Price Index for All Urban Workers) analysis files covering the period 1998–2017."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/38_Notes#id_74",
      "id": "id_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("It is preferable to have both a person frame that covers a known population of interest and to have a relatively high level of confidence that the persons in that population use a consistent person identifier across all jobs. To that end we use the US Census Bureau’s edited version of the Social Security Administration’s master SSN database (the Numident) to create a set of “eligible” workers each year, removing annual earnings records for ineligible workers. The first condition is that an eligible worker must have an SSN that appears on the Numident. Second, each year an “eligible” worker must meet an additional set of conditions: age is between 18 and 70 (inclusive), is not reported dead, and has an active SSN. If the worker has reported earnings in a given year, the worker must also not have more than 12 reported employers during the year, otherwise we assume the SSN is being used by multiple persons and the annual earnings report is discarded.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("The overarching data selection and processing decisions here largely mirror AMZ, and the reader is referred to that paper for additional details. "), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("However, there are a number of additional decisions and assumptions associated with analyzing subnational populations. Because the LEHD data use a job-level frame, locating a worker within a given subnational area (one of the four MSAs versus somewhere else in the country) involves mapping each job to an employer location. This is straightforward for single-establishment employers, where we use the location of the single establishment. Geolocating the job is more difficult for multiestablishment employers because the earnings data are reported at the employer level, not the establishment level in LEHD data. A statistical model is used to impute the location of each job in a multiestablishment employer to one of the physical locations of its establishments. For multiestablishment employers, we use the results of these imputation models to assign each worker to one of the firm’s establishments. Workers with multiple employers in a given year may also have work locations in more than one subnational area and, in that case, we assign the individual’s work location to the establishment at the employer with whom the worker had the highest earnings (dominant) in that year.")])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('p', {
    staticClass: "P4"
  }, [_vm._v("Assigning subnational geography is also complicated when an individual is inactive. For example, we might observe a worker in paid employment in Detroit in a given year, but the same worker may no longer have positive reported earnings in the subsequent year. Although we have the complete set of statutory UI employment records for that individual, we do not know if the worker has entered self-employment, is inactive in Detroit, or inactive in some other subnational area. If and when the worker reappears with positive earnings in a subsequent year, we do not assume a location. Instead, the location of the worker is determined by the location of the dominant employer in the adjacent year. For example, if a worker reappears in Detroit after a year or more of inactivity, then the worker is a new entrant to the Detroit labor market, whether they actually left Detroit or remained in the MSA during the period with no reported UI earnings. For workers with a continuous work history, the location of the dominant employer allows us to observe both within and across MSA earnings mobility.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("Privacy is a substantial concern in studies involving disaggregated LEHD data or other large-scale administrative data sources. In this study, we avoid disclosure risk by limiting ourselves to four very large MSAs and report statistics for very large cells (annual earnings data with wide earnings bins). In the production version of EAMS, where the analysis cell counts and sums are likely to be much smaller, the approach will be to build on existing Census Bureau privacy protection methods and use noise infusion to mitigate the risks of unauthorized disclosure. For an overview of one approach to noise infusion, see Abowd and McKinney (2016). Also, Foote, Machanavajjhala, and McKinney (2019) discuss how to use differentially private noise infusion to estimate earnings distributions and quantiles for the Census PSEO public-use data dissemination tool.")])]), _c('div', {
    staticClass: "C1136"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }), _c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('img', {
    staticClass: "img70",
    attrs: {
      "alt": "",
      "src": "html/images/93_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('p', {
    staticClass: "C1138"
  }, [_c('strong', [_vm._v("Fig. 3.2 Distributions of employment and earnings, all years (1998 to 2017)")])])])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('p', {
    staticClass: "C826"
  }, [_c('strong', [_vm._v("3.3 Inequality")])])]), _c('p', {
    staticClass: "P51"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("Our analysis of earnings inequality and earnings dynamics begins with the overall distributions of employment and earnings across five broad real earnings bins for the US and four large MSAs (DT, LA, NY, SF) over the entire 1998–2017 study period (")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_79"
    }
  }, [_vm._v("figures 3.2a")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_79"
    }
  }, [_vm._v("3.2b")]), _vm._v("). The five real earnings bins are $1–18,000, $18,000–54,000, $54,000–96,000, $96,000–132,000, and greater than $132,000. For the US as a whole, almost 75 percent of the person-year employment observations ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_79"
    }
  }, [_vm._v("figure 3.2a")]), _vm._v(") are in the bottom two bins, a bit over 15 percent are in the third bin, and just under 5 percent of employment is in each of the two top earnings bins. Total earnings ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_79"
    }
  }, [_vm._v("figure 3.2b")]), _vm._v(") skew very differently than employment, with only about 35 percent of total earnings in the first two bins, a bit over 25 percent in the third bin, and over 35 percent in the top two earnings bins combined. While most workers (almost 75 percent) are in the bottom two earnings bins, the 25 percent of workers in the top three earnings bins are responsible for about 65 percent "), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("of total earnings. Perhaps even more striking is the just over one-third of person-year employment in the less than $18,000 real earnings bin accounted for only a bit over 5 percent of total earnings.")])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("The distributions of employment and total earnings within the four MSAs are broadly similar, but a closer look provides the first indication of how inequality differs at the subnational level. Relative to the US totals, all four MSAs have more person-year employment (")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_79"
    }
  }, [_vm._v("figure 3.2a")]), _vm._v(") in the higher earnings bins, consistent with higher earnings in larger MSAs generally. The differences at the very top are most prominent in New York and San Francisco, with Los Angeles not far behind. Detroit has a larger fraction of person-year employment than the US in the top three earnings bins, but the employment is more concentrated in the $54,000–96,000 and $96,000–132,000 bins. The same relative patterns are even more pronounced in the total earnings distributions ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_79"
    }
  }, [_vm._v("figure 3.2b")]), _vm._v("). For example, the $132,000 and higher earnings bin accounted for over 40 percent of total in earnings in New York and San Francisco, but only 25 percent for the US as a whole.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("The Kullback-Leibler (K-L) statistic is a useful summary measure of how each of the MSA-level employment and earnings distributions diverge from the overall US distributions. The K-L statistics for employment ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_858"
    }
  }, [_vm._v("figure 3.3a")]), _vm._v(") and real earnings ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_858"
    }
  }, [_vm._v("figure 3.3b")]), _vm._v(") indicate substantial differences in both levels and trends across the four MSAs. In general, the employment and earnings distributions in Los Angeles and Detroit are most similar to the entire country, and the divergence between the MSA-level and national distributions is not changing substantially over time. The employment distributions in New York and San Francisco are generally more divergent from the national distribution, and the divergence in San Francisco increased dramatically after the Great Recession. The total earnings K-L statistics in New York and San Francisco are generally above the employment K-L statistics and trending up throughout the study period, indicating that in addition to New York and San Francisco having more workers in the higher real earnings bins, average real earnings in the top earnings bins are also higher, and the differences in average real earnings at the top are increasing over time."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/38_Notes#id_78",
      "id": "id_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("Although the measures of inequality shown here (and in the online appendix, "), _c('a', {
    attrs: {
      "href": "http://www.nber.org/data-appendix/c14448/appendix.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://www.nber.org/data-appendix/c14448/appendix.pdf")]), _vm._v(") are informative, the LEHD data are rich enough to answer questions about differences between specific points in the real earnings distributions, whether between MSAs in a given year, or for the same MSA over time. For the next set of results, we discretize the real total earnings distribution into 25 earnings bins. The first 20 real earnings bins have a width of $6,000, the next four bins "), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("have a width of $12,000, and the final bin captures yearly real earnings above $168,000. In ")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_859"
    }
  }, [_vm._v("figure 3.4")]), _vm._v(" we plot pairwise densities for all four MSAs in 1998 and 2017 and for various years for each MSA separately in "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_860"
    }
  }, [_vm._v("figures 3.5–3.8")]), _vm._v(". Before discussing the results, we remind the reader that "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_860"
    }
  }, [_vm._v("figures 3.5–3.8")]), _vm._v(" are total earnings densities. For each bin, rather than sum the number of workers, we sum the earnings for all workers with real annual earnings greater than the minimum bin real earnings value and less than or equal to the top earnings value. Traditional earnings densities are often characterized as log-normal in shape, and the results for the discretized total earnings densities are roughly consistent with a mixture of a log-normal or a log-normal–like distribution with fatter tails (e.g., log-Student-t).")]), _vm._v(" "), _c('div', {
    staticClass: "C1136"
  }, [_c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "id_858"
    }
  }, [_c('img', {
    staticClass: "img60",
    attrs: {
      "alt": "",
      "src": "html/images/95_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "id_858"
    }
  }, [_c('p', {
    staticClass: "C1138"
  }, [_c('strong', [_vm._v("Fig. 3.3 Kullback-Leibler measures of distributional divergence")])])])]), _c('a', {
    attrs: {
      "id": "id_858"
    }
  }), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "id_858"
    }
  }, [_vm._v("The starting point for the density analysis is a comparison of all four ")]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("MSAs, in the first and last years of our study period (")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_859"
    }
  }, [_vm._v("figure 3.4")]), _vm._v(")."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/38_Notes#id_82",
      "id": "id_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_859"
    }
  }, [_vm._v("Figure 3.4a")]), _vm._v(" shows Detroit and Los Angeles in 1998. Los Angeles had more lower-paying (less than $50,000) and more higher-paying (above $168,000) jobs than Detroit, indicated by the thin line above the thick line. Earnings in Detroit were more concentrated in the middle of the earnings distribution (between $50,000 and $100,000)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/38_Notes#id_80",
      "id": "id_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Detroit, in 1998, had substantially more earnings equality than Los Angeles, because of the concentration of middle-earnings jobs. San Francisco ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_859"
    }
  }, [_vm._v("figure 3.4b")]), _vm._v(") was also a relatively equal MSA in 1998 (the Gini was well below New York and Los Angeles) for the same reason—a large fraction of earnings in the $50,000–100,000 range.")]), _vm._v(" "), _c('div', {
    staticClass: "C1136"
  }, [_c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "id_859"
    }
  }, [_c('img', {
    staticClass: "img80",
    attrs: {
      "alt": "",
      "src": "html/images/96_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "id_859"
    }
  }, [_c('p', {
    staticClass: "C1138"
  }, [_c('strong', [_vm._v("Fig. 3.4 Total earnings densities, 1998 and 2017")])])])]), _c('a', {
    attrs: {
      "id": "id_859"
    }
  }), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "id_859"
    }
  }, [_vm._v("The four earnings distributions all shifted to the right between 1998 and 2017, though to very different degrees. Comparing Detroit and Los Angeles (")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_859",
      "id": "page_83"
    }
  }, [_vm._v("figure 3.4c")]), _vm._v("), the rightward shift in Los Angeles is more pronounced, with earnings in the middle of the distribution reallocated to the long right tail. In contrast, the changes in Detroit were relatively modest. The earnings distribution shifts in New York and San Francisco were more dramatic, with a substantial reduction of total earnings in the $50,000–100,000 range and a corresponding greatly increased long right tail."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/38_Notes#id_84",
      "id": "id_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('div', {
    staticClass: "C1136"
  }, [_c('p', {
    staticClass: "C1135"
  }, [_c('img', {
    staticClass: "img70",
    attrs: {
      "alt": "",
      "src": "html/images/97_1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C1138"
  }, [_c('strong', [_vm._v("Fig. 3.4")])])]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("Fluctuations over time in the summary statistics like the Gini coefficient and top-to-bottom share ratios over the study period indicate the rate of change in the shift to the right throughout the study period is not constant. Indeed, this is borne out by comparing discretized densities for each of the four MSAs in 1998, 2007, 2011, and 2017. "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_860"
    }
  }, [_vm._v("Figures 3.5a")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_861"
    }
  }, [_vm._v("3.6a")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_88"
    }
  }, [_vm._v("3.7a")]), _vm._v(", and "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_89"
    }
  }, [_vm._v("3.8a")]), _vm._v(" isolate the prerecession years (1998 and 2007); "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_860"
    }
  }, [_vm._v("figures 3.5b")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_861"
    }
  }, [_vm._v("3.6b")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_88"
    }
  }, [_vm._v("3.7b")]), _vm._v(", and "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_89"
    }
  }, [_vm._v("3.8")]), _vm._v("b focus on the early years of the Great Recession (2007 and 2011); "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_862"
    }
  }, [_vm._v("figures 3.5c")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_863"
    }
  }, [_vm._v("3.6c")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_88"
    }
  }, [_vm._v("3.7c")]), _vm._v(", and "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_89"
    }
  }, [_vm._v("3.8c")]), _vm._v(" look at changes in the latter stages of the recovery ("), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("2011 and 2017); and ")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_862"
    }
  }, [_vm._v("figures 3.5d")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_863"
    }
  }, [_vm._v("3.6d")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_88"
    }
  }, [_vm._v("3.7d")]), _vm._v(", and "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_89"
    }
  }, [_vm._v("3.8d")]), _vm._v(" show the change for the entire period (1998 and 2017). Detroit ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_860"
    }
  }, [_vm._v("figure 3.5")]), _vm._v(") is clearly an outlier among the four MSAs, with relatively little change in the total earnings distribution over the period. There is a modest rightward shift in the middle of the distribution between 1998 and 2007 ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_860"
    }
  }, [_vm._v("figure 3.5a")]), _vm._v("), subsequently reversed by a leftward shift during the recession years ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_860"
    }
  }, [_vm._v("figure 3.5b")]), _vm._v("). There is very little change in the Detroit earnings distribution during the postrecession period 2011–17 ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_862"
    }
  }, [_vm._v("figure 3.5c")]), _vm._v("), and hence little overall change during the entire study period ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_862"
    }
  }, [_vm._v("figure 3.5d")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "C1136"
  }, [_c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "id_860"
    }
  }, [_c('img', {
    staticClass: "img80",
    attrs: {
      "alt": "",
      "src": "html/images/98_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "id_860"
    }
  }, [_c('p', {
    staticClass: "C1138"
  }, [_c('strong', [_vm._v("Fig. 3.5 Total earnings densities, Detroit, various years")])])])]), _c('a', {
    attrs: {
      "id": "id_860"
    }
  }), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "id_860"
    }
  }, [_vm._v("The patterns of shifting earnings distributions in the other three MSAs during the study subperiods all tell a similar story, though with different magnitudes. In Los Angeles (")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_861"
    }
  }, [_vm._v("figure 3.6")]), _vm._v("), New York ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_88"
    }
  }, [_vm._v("figure 3.7")]), _vm._v("), and San Francisco ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_89"
    }
  }, [_vm._v("figure 3.8")]), _vm._v("), earnings were shifting to the right, and especially into the long right tail, between 1998 and 2007. During the Great Recession, earnings distributions essentially locked down, as in Detroit. The stability in the total earnings distributions is the result of lost jobs and labor force exits in the bottom half of the MSA earnings distributions, offset by a lack of growth in earnings at the top. Excluding workers who exited the labor "), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("force after 2007 for economic reasons provides a distorted view of inequality. Earnings certainly became more unequal during the Great Recession. Limiting the population to workers with observed earnings obscures that fact."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/38_Notes#id_86",
      "id": "id_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('div', {
    staticClass: "C1136"
  }, [_c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "id_862"
    }
  }, [_c('img', {
    staticClass: "img80",
    attrs: {
      "alt": "",
      "src": "html/images/99_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "id_862"
    }
  }, [_c('p', {
    staticClass: "C1138"
  }, [_c('strong', [_vm._v("Fig. 3.5")])])])]), _c('a', {
    attrs: {
      "id": "id_862"
    }
  }), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "id_862"
    }
  }, [_vm._v("The postrecession differences in earnings density shifts across MSAs are also notable and help clarify some of the earlier summary inequality statistics. Los Angeles (")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_863"
    }
  }, [_vm._v("figure 3.6c")]), _vm._v(") and New York ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_88"
    }
  }, [_vm._v("figure 3.7c")]), _vm._v(") are to a large extent similar to Detroit for the 2011–17 period, with only a modest additional rightward shift in the earnings distributions. However, San Francisco ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_89"
    }
  }, [_vm._v("figure 3.8c")]), _vm._v(") is a clear outlier, with a dramatic rightward shift in the earnings distribution. This is consistent with the dramatic rise in average earnings in San Francisco relative to the other MSAs after 2011 (see online appendix "), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("figure A1, ")]), _c('a', {
    attrs: {
      "href": "http://www.nber.org/data-appendix/c14448/appendix.pdf",
      "target": "_blank"
    }
  }, [_vm._v("http://www.nber.org/data-appendix/c14448/appendix.pdf")]), _vm._v("), and the jump in the K-L divergence ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_858"
    }
  }, [_vm._v("figure 3.3")]), _vm._v("). Indeed, the continued rightward shift in the San Francisco earnings distribution suggests very different labor market dynamics were in play across the entire distribution.")]), _vm._v(" "), _c('div', {
    staticClass: "C1136"
  }, [_c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "id_861"
    }
  }, [_c('img', {
    staticClass: "img80",
    attrs: {
      "alt": "",
      "src": "html/images/100_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "id_861"
    }
  }, [_c('p', {
    staticClass: "C1138"
  }, [_c('strong', [_vm._v("Fig. 3.6 Total earnings densities, Los Angeles, various years")])])])]), _c('a', {
    attrs: {
      "id": "id_861"
    }
  }, [_c('p', {
    staticClass: "C826"
  }, [_c('strong', [_vm._v("3.4 Mobility")])])]), _c('p', {
    staticClass: "P51"
  }, [_c('a', {
    attrs: {
      "id": "id_861"
    }
  }, [_vm._v("Snapshots of earnings distributions and summary inequality statistics across years are a useful way to describe a given local economy at a point in time, but the static pictures tell us little about individual earnings dynamics. One recurring example from the previous section—the finding that earnings inequality seemed to fall or was stagnant during the Great Recession—is an artifact of earnings distributions and summary statistics excluding those who exited the labor market. Of course, the workers who suffered the biggest earnings losses during the Great Recession are excluded from measures such as the Gini, top shares, and earnings densities. As a result, those earnings losses are not captured in the traditional comparative snapshot approach. ")]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_vm._v("The solution is to shift the perspective from static to dynamic, and to focus on employment and earnings mobility.")])]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }), _c('div', {
    staticClass: "C1136"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }), _c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }), _c('a', {
    attrs: {
      "id": "id_863"
    }
  }, [_c('img', {
    staticClass: "img80",
    attrs: {
      "alt": "",
      "src": "html/images/101_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "id_863"
    }
  }, [_c('p', {
    staticClass: "C1138"
  }, [_c('strong', [_vm._v("Fig. 3.6")])])])]), _c('a', {
    attrs: {
      "id": "id_863"
    }
  }), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "id_863"
    }
  }, [_vm._v("Shifting to a dynamic perspective involves comprehensively tracking workers across earnings bins and nonemployment status. All workers in the mobility samples in this section meet the eligibility criteria described in section 3.2 in all of the periods considered for the given statistic. Thus, for example, a worker must be eligible in both year "), _c('em', [_vm._v("t")]), _vm._v(" and "), _c('em', [_vm._v("t")]), _vm._v(" + 1 and have positive earnings in at least one of the two years; workers who are not active both years are not included. We allocate workers within each MSA across the five real earnings bins used in the first figures in the previous section (")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_79"
    }
  }, [_vm._v("figures 3.2a")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_79"
    }
  }, [_vm._v("3.2b")]), _vm._v("), along with eligible but inactive workers who are active in the adjacent year, and eligible active workers who transition to or from a different MSA."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/38_Notes#id_88",
      "id": "id_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Thus, there are seven distinct possible bins for an eligible worker in a given year: one of the five earnings bins, not active, and active in a different MSA."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/html/38_Notes#id_90",
      "id": "id_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('div', {
    staticClass: "C1136"
  }, [_c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('img', {
    staticClass: "img40",
    attrs: {
      "alt": "",
      "src": "html/images/102_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('p', {
    staticClass: "C1138"
  }, [_c('strong', [_vm._v("Fig. 3.7 Total earnings densities, New York, various years")])])])]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }), _c('div', {
    staticClass: "C1136"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }), _c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_c('img', {
    staticClass: "img40",
    attrs: {
      "alt": "",
      "src": "html/images/103_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_c('p', {
    staticClass: "C1138"
  }, [_c('strong', [_vm._v("Fig. 3.8 Total earnings densities, San Francisco, various years")])])])]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "page_89"
    }
  }), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("It is useful to begin with a high-level view of two-year mobility across the four MSAs in the base period, 1998. Eligible workers in 1998 experienced one of seven broadly defined earnings transitions. An individual could have "), _c('em', [_vm._v("stayed")]), _vm._v(" in the same earnings bin in 1999 (S), moved "), _c('em', [_vm._v("up")]), _vm._v(" to a higher earnings bin (U), moved "), _c('em', [_vm._v("down")]), _vm._v(" to a lower earnings bin (D), "), _c('em', [_vm._v("exited")]), _vm._v(" to inactivity (X), "), _c('em', [_vm._v("entered")]), _vm._v(" from inactivity (E), "), _c('em', [_vm._v("left")]), _vm._v(" the reference MSA for employment elsewhere (L), or "), _c('em', [_vm._v("moved")]), _vm._v(" into the MSA from elsewhere (M). At this very high level of aggregation, there is a great deal of commonality across MSAs in terms of mobility. In particular, about half of all workers in the four MSAs were in the same earnings bin in both 1998 and 1999. Flows in and out of activity within the given MSA were generally on the order of 5 percent of workers, and gross migration (inflows and outflows) were generally balanced, each between 5 and 10 percent of the population. Most workers who were continuously employed in an MSA between 1998 and 1999 but changed earnings bins experienced upward mobility (roughly 10–13 percent) as opposed to downward mobility (roughly 6–8 percent).")])]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("Although the transition rates between 1998 and 1999 seem fairly homogeneous across MSAs, transition patterns evolved somewhat differently after 1999. To show this, we plot transitions for each year-pair 1999/2000, 2001/2002, . . . , 2016/2017, relative to the base 1998/1999 transitions (")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_91"
    }
  }, [_vm._v("figures 3.9")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_92"
    }
  }, [_vm._v("3.10")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_93"
    }
  }, [_vm._v("3.11")]), _vm._v(", and "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_94"
    }
  }, [_vm._v("3.12")]), _vm._v("). For each MSA, we show whether the worker stayed in the same bin, moved up one or more bins, or moved down one or more bins earnings transitions ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_91"
    }
  }, [_vm._v("figures 3.9a")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_92"
    }
  }, [_vm._v("3.10a")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_93"
    }
  }, [_vm._v("3.11a")]), _vm._v(", and "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_94"
    }
  }, [_vm._v("3.12a")]), _vm._v("); entrants and exits from inactivity ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_91"
    }
  }, [_vm._v("figures 3.9b")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_92"
    }
  }, [_vm._v("3.10b")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_93"
    }
  }, [_vm._v("3.11b")]), _vm._v(", and "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_94"
    }
  }, [_vm._v("3.12b")]), _vm._v("); and leavers and movers to the reference MSA("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_91"
    }
  }, [_vm._v("figures 3.9b")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_92"
    }
  }, [_vm._v("3.10b")]), _vm._v(", "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_93"
    }
  }, [_vm._v("3.11b")]), _vm._v(", and "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_94"
    }
  }, [_vm._v("3.12b")]), _vm._v("). In each MSA/figure, a value of 1 for a given year-pair indicates that the number of workers experiencing that transition is identical to the number of workers who experienced that transition in 1998/99. Values above 1 indicate more workers experiencing the transition (relative to 1998/99) in the given year, and vice versa.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("There are both trend differences and common cycles in the relative mobility rates across MSAs. The most obvious commonality is in the entry and exit between paid employment and inactivity (b in each of the figures). Rates of exit to inactivity from paid employment were higher over most of the prerecession period and surged in 2008 and 2009 at the start of the Great Recession, while rates of entry from inactivity to paid employment fell. In addition, except for San Francisco there was no increase in the rate of return to paid employment from inactivity after 2010. Rather, rates of entry (including reentry) rose quickly until 2010 and then stagnated or fell, consistent with a slow decline in unemployment and the prolonged declines in measured labor force participation in the wake of the Great Recession. On net, by the end of the study period, the number of workers entering and exiting paid employment had generally converged back to the 1998/99 levels, except in Detroit, where inflows and outflows were each about 20 percent below the base period.")]), _vm._v(" "), _c('div', {
    staticClass: "C1136"
  }, [_c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_c('img', {
    staticClass: "img40",
    attrs: {
      "alt": "",
      "src": "html/images/105_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_c('p', {
    staticClass: "C743"
  }, [_c('strong', [_vm._v("Fig. 3.9 Mobility relative to base year, Detroit")])]), _vm._v(" "), _c('p', {
    staticClass: "C1138"
  }, [_c('em', [_vm._v("Note")]), _vm._v(": Base year 1998 shares are in parentheses.")])])]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }), _c('div', {
    staticClass: "C1136"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }), _c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_c('img', {
    staticClass: "img40",
    attrs: {
      "alt": "",
      "src": "html/images/106_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_c('p', {
    staticClass: "C743"
  }, [_c('strong', [_vm._v("Fig. 3.10 Mobility relative to base year, Los Angeles")])]), _vm._v(" "), _c('p', {
    staticClass: "C1138"
  }, [_c('em', [_vm._v("Note")]), _vm._v(": Base year 1998 shares are in parentheses.")])])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }), _c('div', {
    staticClass: "C1136"
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }), _c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_c('img', {
    staticClass: "img40",
    attrs: {
      "alt": "",
      "src": "html/images/107_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_c('p', {
    staticClass: "C743"
  }, [_c('strong', [_vm._v("Fig. 3.11 Mobility relative to base year, New York")])]), _vm._v(" "), _c('p', {
    staticClass: "C1138"
  }, [_c('em', [_vm._v("Note")]), _vm._v(": Base year 1998 shares are in parentheses.")])])]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }), _c('div', {
    staticClass: "C1136"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }), _c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('img', {
    staticClass: "img40",
    attrs: {
      "alt": "",
      "src": "html/images/108_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('p', {
    staticClass: "C743"
  }, [_c('strong', [_vm._v("Fig. 3.12 Mobility relative to base year, San Francisco")])]), _vm._v(" "), _c('p', {
    staticClass: "C1138"
  }, [_c('em', [_vm._v("Note")]), _vm._v(": Base year 1998 shares are in parentheses.")])])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("What happened to earnings for those who remained employed in each year/pair combination? It is important to keep in mind that the reference point for mobility among the continuously employed is the 1998/99 year-pair, and upward mobility in Detroit was relatively strong in that period (")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_91"
    }
  }, [_vm._v("figure 3.9a")]), _vm._v(") and thus all of the subsequent years have noticeably lower upward mobility. The more salient observation about upward mobility in Detroit is that the relative number of workers experiencing upward mobility in Detroit, fell from 2000 forward, compared to 1998, but the absolute number remained constant, as evidenced by the flat line. Conversely, the number of workers experiencing downward mobility was higher than in the base period between 2000 and into the Great Recession, but has since remained lower.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("Relative patterns of upward and downward mobility across the other MSAs differ to some extent, although there are similarities. For example, there are temporary offsetting movements in upward and downward mobility during the Great Recession, while unlike in Detroit the (relative) number of workers remaining in the same real earnings bin climbed steadily over the 20-year study period. While job destruction and the increased level of inactivity associated with recessions (deservedly) get most of the attention in the macro-labor literature, the cyclical decrease in upward mobility is also an important feature, because those who remained in paid employment were much less likely to see large earnings increases. And, although the fraction of continuously employed remaining in a given earnings bin from one year to the next is obviously dependent on the earnings bin specification, the general upward trend in “same bin” transitions and the lower level (relative) of up and down earnings mobility across MSAs is consistent with decreased wage dynamism.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("The final transition needed to complete our mobility taxonomy is leavers and movers for each MSA. Again, the fact that these are relative transitions should be kept in mind when evaluating Detroit over time in comparison to the other three MSAs. In the 1998–99 reference period, Detroit experienced fairly high rates of leaving (to another MSA) and moving in (from another MSA). Somewhat counterintuitively, workers moving in also outpaced workers moving out in Detroit during the base year-pair, so the fact that both leaving and moving are lower after 2000 is less of a mystery than a first impression suggests. In general, geographic mobility is cyclical across MSAs, as rates of both leaving and moving declined during the Great Recession "), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("in all four areas. The sense in which Detroit stands out is that geographic mobility did not increase after the Great Recession ended, as it did in the other three MSAs.")])]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }), _c('div', {
    staticClass: "C1136"
  }, [_c('a', {
    attrs: {
      "id": "page_96"
    }
  }), _c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "page_96"
    }
  }), _c('a', {
    attrs: {
      "id": "id_864"
    }
  }, [_c('img', {
    staticClass: "img80",
    attrs: {
      "alt": "",
      "src": "html/images/110_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "id_864"
    }
  }, [_c('p', {
    staticClass: "C1138"
  }, [_c('strong', [_vm._v("Fig. 3.13 Earnings dynamics between 2008 and 2012, San Francisco")])])])]), _c('a', {
    attrs: {
      "id": "id_864"
    }
  }, [_c('p', {
    staticClass: "P4"
  }, [_vm._v("Classifying mobility using the seven broad categories is a good starting point, but it is possible to drill down even further and investigate how, for example, mobility varies by where the worker started in terms of earnings bin, inactivity, or working in a different MSA. One can study how earnings dynamics (as measured by average earnings) interact with the starting point and mobility path. Mobility is more than a two-period concept, and it is also useful to investigate how multiperiod mobility differs from single-period mobility along a given dynamic path. Is there evidence of mean reversion or reinforcing positive or negative earnings shocks along a given path? These are the sorts of detailed questions which the new Census Bureau EAMS web application is being designed to answer, and we conclude this section with an example of how one might deconstruct earnings dynamics in a given MSA for a given time period.")])]), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "id_864"
    }
  }, [_vm._v("Our specific example is the San Francisco MSA for the years 2008 through 2012 (")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_864"
    }
  }, [_vm._v("figure 3.13")]), _vm._v("). Each subfigure ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_864"
    }
  }, [_vm._v("figure 3.13a–g")]), _vm._v(") has two components, a "), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("pie chart showing the fraction of workers along a given mobility path, and a line chart showing the average earnings of workers on that mobility path in each of the five years. The seven subfigures comprehensively capture the workers in the seven status bins as of 2008, where 0 represents inactivity (no earnings in 2008); bins 1, 2, 3, 4, and 5 represent the five fixed real earnings bins (less than $18,000 through $132,000 or more); and 6 represents workers ")]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("outside the reference MSA. A given transition path within any given subfigure is represented using bin numbers pairs, so “01” indicates the worker was in bin 0 (inactive) in 2008, and bin 1 (positive earnings, less than $18,000) in 2009. We will refer to that as the “01” mobility path.")])]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }), _c('div', {
    staticClass: "C1136"
  }, [_c('a', {
    attrs: {
      "id": "page_98"
    }
  }), _c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "page_98"
    }
  }), _c('a', {
    attrs: {
      "id": "id_865"
    }
  }, [_c('img', {
    staticClass: "img50",
    attrs: {
      "alt": "",
      "src": "html/images/111_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "id_865"
    }
  }, [_c('p', {
    staticClass: "C1138"
  }, [_c('strong', [_vm._v("Fig. 3.13")])])])]), _c('a', {
    attrs: {
      "id": "id_865"
    }
  }), _c('div', {
    staticClass: "C1136"
  }, [_c('a', {
    attrs: {
      "id": "id_865"
    }
  }), _c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "id_865"
    }
  }), _c('a', {
    attrs: {
      "id": "id_866"
    }
  }, [_c('img', {
    staticClass: "img80",
    attrs: {
      "alt": "",
      "src": "html/images/112_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "id_866"
    }
  }, [_c('p', {
    staticClass: "C1138"
  }, [_c('strong', [_vm._v("Fig. 3.13")])])])]), _c('a', {
    attrs: {
      "id": "id_866"
    }
  }, [_c('p', {
    staticClass: "P4"
  }, [_vm._v("One gets a sense of how complex nonparametric analysis of earnings dynamics quickly becomes by first noting we need seven subfigures, each with two separate charts, simply to describe earnings paths and average earnings along those paths for one MSA in one base year. The first subfigure shows outcomes for workers who were in the inactive group (bin 0) in 2008. The pie chart shows that the most likely path for such workers who entered paid employment was by far entry into the lowest earnings bin—the “01” path. The second most likely path was 02, and the third was 03. Only a very small fraction of workers (too small to display) transitioned from inactivity to earnings bins 4 and 5 between 2008 and 2009.")])]), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "id_866"
    }
  }, [_vm._v("Conditional on entering a given earnings bin, the trajectory of average workers entering from inactivity were all positive. The immediate fanning out of average earnings is determined by the bin into which the worker entered, with the 01 group earning about $10,000 in 2009, the 02 group about ")]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("$30,000 in 2009, and the 03 group about $70,000 in 2009. All three groups experienced continued average earnings growth between 2009 and 2012, though in relative terms the most substantial growth was for the 01 group, who saw their average earnings more than double during the four years after they entered from inactivity. Workers in the 03 group still saw substantial real gains, with average earnings approaching $100,000 by 2012.")])]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("The earnings dynamics of workers who started the 2008 to 2012 period with positive earnings in 2008 confirm the findings on earnings stability noted earlier in this section, and the findings on similar trajectories in years three and beyond just noted for the inactive in 2008. The pie charts in ")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_864"
    }
  }, [_vm._v("figure 3.13b–f")]), _vm._v(" show that the majority of workers who had positive earnings in the San Francisco MSA in 2008 remained in the same earnings bin in 2009. Low earners were more likely to transition to inactivity in 2009, as indicated by the slices of the respective pie charts associated with the 10, 20, 30, 40, and 50 earnings paths. However, the line charts show that, conditional on experiencing a transition to inactivity, average earnings bounced back quickly for those workers after 2009. Average earnings for those experiencing inactivity in 2009 moved back into line with the levels and trajectories of average earnings for workers who remained in paid employment during 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("One particularly interesting subset of earnings paths involves those who leave the reference MSA—in this case, San Francisco—in 2008, and immediately find paid employment in another MSA. These transitions are captured in the 16 path ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_864"
    }
  }, [_vm._v("figure 3.13b")]), _vm._v("), 26 ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_865"
    }
  }, [_vm._v("figure 3.13c")]), _vm._v("), 36 ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_865"
    }
  }, [_vm._v("figure 3.13d")]), _vm._v("), 46 ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_865"
    }
  }, [_vm._v("figure 3.13e")]), _vm._v("), and 56 path ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_866"
    }
  }, [_vm._v("figure 3.13f")]), _vm._v("). These MSA leavers account for nearly a fifth of bin 1 earners in 2008, and about 10 percent of workers in bins 2–5. In every case, the average earnings of MSA leavers track the average earnings of those who remain in their same earnings bin between 2008 and 2009. Average earnings are rising over time for workers in bin 1 who left San Francisco, and generally flat for workers in bins 2–5 who left San Francisco, but in all cases they move in the same direction as those who stayed in the earnings bin (and likely the same job) but did not leave San Francisco.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("The final subfigure ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_866"
    }
  }, [_vm._v("figure 3.13g")]), _vm._v(") captures movers to San Francisco in 2009. For these workers, we observe earnings in some other MSA in 2008, and thus we can bin their earnings as of 2008. As indicated by the pie chart, the majority of movers to San Francisco in 2009 were in the two lowest earnings bins, with about 40 percent in bin 1, and another 30 percent in bin 2. Thus, at least during the depths of the Great Recession, moving to San Francisco was not dominated by high-earning workers. In addition, the basically flat average earnings trajectories across origination earnings bins suggest that, again—at least during this time period—moving to San Francisco was not associated with observable upward changes in earnings trajectories. One has to look at the subset of high earnings—the 56-transition group—to see any positive earnings gains, and that is only in 2012.")]), _vm._v(" "), _c('div', {
    staticClass: "C1136"
  }, [_c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_c('img', {
    staticClass: "Image380",
    attrs: {
      "alt": "",
      "src": "html/images/114_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_c('p', {
    staticClass: "C1138"
  }, [_c('strong', [_vm._v("Fig. 3.14 One-year arc-percent change in real earnings")])])])]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_c('p', {
    staticClass: "C826"
  }, [_c('strong', [_vm._v("3.5 Volatility")])]), _vm._v(" "), _c('p', {
    staticClass: "P51"
  }, [_vm._v("Upward earnings mobility—as defined in the previous section—is an unambiguously desirable economic outcome. The more workers who move up the job ladder to higher-paying jobs from one year to the next, the better. Earnings volatility is a bit more nuanced, however. While it is desirable that workers should not be subject to increased uncertainty about their real annual earnings, measured overall earnings volatility will also decrease when upward mobility decreases. Thus, it is important to measure overall volatility, but then disaggregate that overall volatility using the same fixed earnings bins approach we have used to study inequality and mobility to get a sense of "), _c('em', [_vm._v("where")]), _vm._v(" in the mobility distribution measured volatility is most prominent.")])]), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("There are various ways to measure overall earnings volatility in a given year, and here we focus on the standard deviation of the one-year arc-percent change between the current and the subsequent year (")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_100"
    }
  }, [_vm._v("figure 3.14")]), _vm._v("). At the overall MSA level, there is a clear downward trend in earnings volatility over the study period, which is consistent with a continuation of the trends found in earlier studies (Bloom et al. 2017; McKinney and Abowd, 2019). As expected, the Great Recession is associated with a cyclical uptick in volatility, especially in Detroit, but the downward trend resumes after the recession in all four local economies. By 2016–17, measured overall volatility is noticeably lower than in 1998–99, especially in Detroit and New York.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("A decline in measured earnings volatility is a normatively good thing if it is associated with particular earnings trajectories. For example, if all workers are on a general upward earnings trend, then a decline in measured volatility around that trend is good news, because workers are achieving the same long-run earnings outcomes with less uncertainty. However, measured volatility can also decline because of a trend decline in upward mobility. Although overall measured earnings volatility increased during the Great Recession, earnings volatility moved in different directions at different points in the "), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("earnings distribution (Bloom et al. 2017). Workers in the bottom half of the earnings distribution saw a spike in volatility associated with job loss, while workers in the top half of the distribution saw a decrease in volatility because real salary increases were very limited during the recession."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/38_Notes#id_94",
      "id": "id_93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" It is unclear whether the continued decline in measured overall earnings volatility after the recession is being driven by a reversal of the volatility for low-earning workers or by a continued decline in upward mobility.")]), _vm._v(" "), _c('div', {
    staticClass: "C1136"
  }, [_c('p', {
    staticClass: "C1135"
  }, [_c('a', {
    attrs: {
      "id": "id_867"
    }
  }, [_c('img', {
    staticClass: "Image380",
    attrs: {
      "alt": "",
      "src": "html/images/115_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "id_867"
    }
  }, [_c('p', {
    staticClass: "C1138"
  }, [_c('strong', [_vm._v("Fig. 3.15 Absolute value of the arc-percent change (bars) and the share of MSA year sum of squares (line)")])])])]), _c('a', {
    attrs: {
      "id": "id_867"
    }
  }), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "id_867"
    }
  }, [_vm._v("Our particular measure of earnings volatility—the standard deviation of the one-year arc-percent change—is disproportionately influenced by large percentage changes in very low earnings. For example, workers in our real earnings bin 1 have total annual earnings of less than $18,000. A worker who moves from (say) $5,000 in one year to $15,000 in the next year contributes an arc-percent change of 1 or 100 percent to the overall average, even though that change is much less economically significant relative to another worker moving from $50,000 to $150,000, which contributes the same 100 percent to the overall average. One solution to this problem is to limit the sample to workers with earnings above a preset threshold but, as suggested by the mobility analysis above, this sort of sample exclusion reduces the impact of labor force inactivity on actual earnings volatility."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/html/38_Notes#id_92",
      "id": "id_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" In addition, these thresholds are generally set so low (say, part-time at the minimum wage or the Social Security qualifying threshold) that some relatively small changes in dollar earnings are still large in percentage terms.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("There are various ways to sort out the impact of volatility in different parts of the earnings distribution ("), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_867"
    }
  }, [_vm._v("figure 3.15")]), _vm._v("), and the approach we take here is to "), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("tie that decomposition back to our mobility analysis in the previous section. The vertical bars show the average of the absolute value of each worker’s arc percentage change in each one-year mobility path, again denoted 11, 12, 13, and so on, to refer to the origination and destination bin. The average absolute arc percentage changes are then ranked from highest volatility transitions (earnings bin 5 to earnings bin 1, earnings bin 1 to earnings bin 5, etc.) to lowest volatility transitions (those who remained in earnings bin 4). The rank-order of the bars captures the two distinct determinants of measured volatility, as movements across bins far apart (15 or 51) suggests a large absolute earnings change, and if one of those bins is a low earnings bin, the dollar change is magnified because the base for the arc-percent change is lower.")])]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }), _c('p', {
    staticClass: "P4"
  }, [_c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("The thick line overlaid on the bars in ")]), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#id_867"
    }
  }, [_vm._v("figure 3.15")]), _vm._v(" shows how much the variability along each of the different mobility paths contributes to overall measured volatility. For example, although the 15 and 51 paths for earnings mobility exhibit extreme volatility (as indicated by the height of the bars), there are so few workers on those paths that the impact on overall volatility is negligible (the thick line is close to zero). The largest single contributor to overall volatility is the 11-path for earnings mobility, which has workers with real earnings between $1 and $18,000 in both years of the pairwise arc-percent change. Measured volatility along the 11 path is about one-third that of the 15 or 51 path, but there are so many workers on the 11 path that they account for almost one-third of overall volatility during the study period. Again, this reinforces the observations above that volatility is a highly nonlinear concept, and specific trends in overall measures (as in "), _c('a', {
    attrs: {
      "href": "#/html/13_3__United_States_Earnings_Dynami#page_100"
    }
  }, [_vm._v("figure 3.14")]), _vm._v(") should be interpreted with caution.")]), _vm._v(" "), _c('p', {
    staticClass: "C826"
  }, [_c('strong', [_vm._v("3.6 Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "P51"
  }, [_vm._v("The primary goal of this chapter is to demonstrate the substantial heterogeneity across subnational areas of the US. For the four large MSAs we analyze, there are clear national trends represented in each of the local areas, the most prominent of which is the increase in the share of earnings accruing to workers at the top of the earnings distribution in 2017 compared with 1998. However, the magnitude of these trends varies across MSAs, with New York and San Francisco showing relatively large increases and Los Angeles somewhere in the middle relative to Detroit, whose total real earnings distribution is relatively stable over the period.")]), _vm._v(" "), _c('p', {
    staticClass: "P4"
  }, [_vm._v("A second goal is to show the important role of earnings mobility. Large changes in earnings typically occur either though job change or internal promotion. Our measure captures both and provides a comprehensive view of the change in the earnings distributions. One potentially concerning trend is the decrease in the ratio of the sum of workers moving up to a higher earnings bin or down to a lower earnings bin relative to the number of workers "), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("staying in the same bin. The reduced worker earnings mobility observed over the analysis period potentially has long-term productivity implications if workers choose to stay in jobs with a relatively poor match rather than move to a better match either at the same or a new firm. The reduction in earnings mobility is especially strong in both Detroit and New York, a result worthy of further investigation.")])]), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_c('p', {
    staticClass: "P4"
  }, [_vm._v("When estimating earnings distributions and earnings mobility, we take a nonparametric approach to estimation. This approach allows us to show detailed local area information in a flexible way, although at the cost of a large number of estimated parameters. The traditional venue of the academic research paper is not ideal for displaying our results, which is why we are developing an interactive dissemination application at the US Census Bureau. We hope the reader is able to see in this chapter a glimpse of our ultimate goal, which is to allow for the interactive display of detailed earnings and mobility statistics for MSAs across the US.")]), _vm._v(" "), _c('p', {
    staticClass: "C754"
  }, [_c('strong', [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Abel, Jaison R., and Richard Deitz. 2019. “Why Are Some Places so Much More Unequal than Others?” "), _c('em', [_vm._v("Economic Policy Review")]), _vm._v(" 25 (1): 58–75.")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Abowd, John M., and Kevin L. McKinney. 2016. “Noise Infusion as a Confidentiality Protection Measure for Graph-based Statistics.” "), _c('em', [_vm._v("Statistical Journal of the International Association for Official Statistics")]), _vm._v(" 32: 127–32.")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Abowd, John M., Kevin L. McKinney, and Ian M. Schmutte. 2019. “Modeling Endogenous Mobility in Earnings Determination.” "), _c('em', [_vm._v("Journal of Business and Economic Statistics")]), _vm._v(" 37 (3): 405–18.")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Abowd, John M., Kevin L. McKinney, and Nellie Zhao. 2018. “Earnings Inequality and Mobility Trends in the United States: Nationally Representative Estimates from Longitudinally Linked Employer-Employee Data.” "), _c('em', [_vm._v("Journal of Labor Economics")]), _vm._v(" 36 (S1): 183–300.")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Abowd, John M., Bryce Stephens, Lars Vilhuber, Fredrik Andersson, Kevin L. McKinney, Marc Roemer, and Simon Woodcock. 2009. “The LEHD Infrastructure Files and the Creation of the Quarterly Workforce Indicators.” In "), _c('em', [_vm._v("Producer Dynamics: New Evidence from Micro Data")]), _vm._v(", edited by Timothy Dunne, J. Bradford Jensen and Mark J. Roberts, 149–230. Chicago: University of Chicago Press.")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Austin, Benjamin, Edward Glaeser, and Lawrence Summers. 2018. “Jobs for the Heartland: Place-Based Policies in 21st-Century America.” "), _c('em', [_vm._v("Brookings Papers on Economic Activity")]), _vm._v(" (Spring): 151–255.")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Autor, David H., David Dorn, and Gordon H. Hanson. 2013. “The China Syndrome: Local Labor Market Effects of Import Competition in the United States.” "), _c('em', [_vm._v("American Economic Review")]), _vm._v(" 103 (6): 2121–68.")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Beraja, Martin, Andreas Fuster, Erik Hurst, and Joe Vavra. 2018. “Regional Heterogeneity and the Refinancing Channel of Monetary Policy.” "), _c('em', [_vm._v("Quarterly Journal of Economics")]), _vm._v(" 134 (1): 109–83.")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Beraja, Martin, Erik Hurst, and Juan Ospina. 2019. “The Aggregate Implications of Regional Business Cycles.” "), _c('em', [_vm._v("Econometrica")]), _vm._v(" 87 (6): 1789–833.")])]), _c('p', {
    staticClass: "C745"
  }, [_c('a', {
    attrs: {
      "id": "page_103"
    }
  }), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("Bloom, Nicholas, Fatih Guvenen, Luigi Pistaferri, John Sabelhaus, Sergio Salgadok, and Jae Song. 2017. “The Great Micro Moderation.” Working paper (April).")])]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }), _c('p', {
    staticClass: "C745"
  }, [_c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("Bureau of Economic Analysis. 2015. “GDP by Metropolitan Area Methodology.” ")]), _c('a', {
    attrs: {
      "href": "https://www.bea.gov/sites/default/files/methodologies/GDPMetro2015.pdf",
      "target": "_blank"
    }
  }, [_vm._v("https://www.bea.gov/sites/default/files/methodologies/GDPMetro2015.pdf")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Bureau of Economic Analysis. 2019. “GDP by County, Metro, and Other Areas.” "), _c('a', {
    attrs: {
      "href": "https://www.bea.gov/data/gdp/gdp-county-metro-and-other-areas",
      "target": "_blank"
    }
  }, [_vm._v("https://www.bea.gov/data/gdp/gdp-county-metro-and-other-areas")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Congressional Budget Office (CBO). 2019. “The Distribution of Household Income, 2016.” Research Report. Washington, DC: Congressional Budget Office. "), _c('a', {
    attrs: {
      "href": "https://www.cbo.gov/system/files/2019-07/55413-CBO-distribution-of-household-income-2016.pdf",
      "target": "_blank"
    }
  }, [_vm._v("https://www.cbo.gov/system/files/2019-07/55413-CBO-distribution-of-household-income-2016.pdf")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Foote, Andrew, Ashwin Machanavajjhala, and Kevin McKinney. 2019. “Releasing Earnings Distributions Using Differential Privacy: Disclosure Avoidance System for Post-Secondary Employment Outcomes (PSEO).” "), _c('em', [_vm._v("Journal of Privacy and Confidentiality")]), _vm._v(" 9 (2). "), _c('a', {
    attrs: {
      "href": "https://journalprivacyconfidentiality.org/index.php/jpc/article/view/722",
      "target": "_blank"
    }
  }, [_vm._v("https://journalprivacyconfidentiality.org/index.php/jpc/article/view/722")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Haltiwanger, John C., Henry R. Hyatt, Lisa B. Kahn, and Erika McEntarfer. 2018. “Cyclical Job Ladders by Firm Size and Firm Wage.” "), _c('em', [_vm._v("American Economic Journal: Macroeconomics")]), _vm._v(" 10 (2): 52–85.")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Haltiwanger, John C., Henry Hyatt, and Erika McEntarfer. 2018. “Who Moves up the Job Ladder?” "), _c('em', [_vm._v("Journal of Labor Economics")]), _vm._v(" 36 (S1): S301–S336.")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Hyatt, Henry, Erika McEntarfer, Kevin Mckinney, Stephen Tibbets, and Doug Walton. 2014. “Job-to-Job (J2J) Flows: New Labor Market Statistics from Linked Employer-Employee Data.” "), _c('em', [_vm._v("JSM Proceedings: Business and Economics Statistics Section")]), _vm._v(", 98–110. Alexandria, VA: American Statistical Association.")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("McEntarfer, Erika, John Haltiwanger, Melissa Bjelland, and Bruce Fallick. 2011. “Employer-to-Employer Flows in the United States: Estimates Using Linked Employer-Employee Data.” "), _c('em', [_vm._v("Journal of Business and Economic Statistics")]), _vm._v(" 29 (4): 493–505.")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("McKinney, Kevin L., and John M. Abowd. 2019. “Male Earnings Volatility in LEHD before, during, and after the Great Recession.” Paper presented at the 2019 AEA Meetings in Atlanta, GA.")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Mian, Atif, Kamalesh Rao, and Amir Sufi. 2013. “Household Balance Sheets, Consumption, and the Economic Slump.” "), _c('em', [_vm._v("Quarterly Journal of Economics")]), _vm._v(" 128 (4): 1687–726.")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Piketty, Thomas, Emmanuel Saez, and Gabriel Zucman. 2018 “Distributional National Accounts: Methods and Estimates for the United States.” "), _c('em', [_vm._v("Quarterly Journal of Economics")]), _vm._v(" 133 (2): 553–609.")]), _vm._v(" "), _c('p', {
    staticClass: "C745"
  }, [_vm._v("Sabelhaus, John, and Jae Song. 2010. “The Great Moderation in Micro Labor Earnings.” "), _c('em', [_vm._v("Journal of Monetary Economics")]), _vm._v(" 57 (4): 391–403.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55358155","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/13_3__United_States_Earnings_Dynami.vue
// module id = 93
// module chunks = 0